import Utils from "../../services/Utils.js";
import {} from "../../js/api/leagues.js";
import { getLeagues } from "../../js/api/leagues.js";
import { getFeaturedMatches } from "../../js/api/featuredPreMatch.js";
import { _t } from "../../services/TranslationService.js";
let leagues = [];
let Leagues = {
  render: async () => {
    let request = Utils.parseRequestURL();
    leagues = await getLeagues(request.id);

    let sportId = "";
    if (!leagues.length == 0) {
      sportId = leagues[0].sport_id;
    } else {
      sportId = 1;
    }

    let sportName = "";
    if (!leagues.length == 0) {
      sportName = leagues[0].sport;
    } else {
      sportName = 1;
    }
    let featuredPrematchView = "";
    let featuredPrematchs = await getFeaturedMatches(sportId);

    let leagueView = "";
    leagues.forEach((league) => {
      // <a href="#/p/${post.id}">${post.title}</a>
      leagueView =
        leagueView +
        `<a class="leagueListContentItem" href="#/games/${league.id}" data-id="${league.id}">${league.name}</a>`;
    });

    if (!featuredPrematchs.length == 0)
      featuredPrematchs.forEach((featuredPrematch) => {
        if (featuredPrematch.odd) {
          const date = new Date(featuredPrematch.game_date);
          let dd = String(date.getDate()).padStart(2, "0");
          let mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
          let yyyy = date.getFullYear();

          const time = `${featuredPrematch.game_time.split(":")[0]}:${featuredPrematch.game_time.split(":")[1]}`;
          featuredPrematchView =
            featuredPrematchView +
            `<div class="featuredPrematchItem">
                   <a href="#/Match/${featuredPrematch.id}" class="featuredMatchName">
                       <span>${featuredPrematch.home_team}</span>
                       <span>${featuredPrematch.away_team}</span>
                    </a>
                    <span class="featurePreMatchDate">${dd}/${mm} ${time}</span>
                    <span class="numberofmarkets">${featuredPrematch.count_options} ></span>
                    <div class="featuredMatchBtn">
                        <div class="singleHomeOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${featuredPrematch.odd.split(",")[0].split("|")[0]}" match-odd="${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${featuredPrematch.odd.split(",")[0].split("|")[2]}" coef-id="${featuredPrematch.odd.split(",")[0].split("|")[0]}" bet-id="${featuredPrematch.odd.split(",")[0].split("|")[0]}" game-id="${featuredPrematch.id}"><i>${featuredPrematch.odd.split(",")[0].split("|")[2]}</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                         <div class="singleDrawOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${featuredPrematch.odd.split(",")[1].split("|")[0]}" match-odd="${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${featuredPrematch.odd.split(",")[1].split("|")[2]}" coef-id="${featuredPrematch.odd.split(",")[1].split("|")[0]}" bet-id="${featuredPrematch.odd.split(",")[1].split("|")[0]}" game-id="${featuredPrematch.id}"><i>${featuredPrematch.odd.split(",")[1].split("|")[2]}</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[1].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>
                        ${featuredPrematch.odd.split(",").length > 2 ? `<div class="singleAwayOdd bettingBtn ${Math.floor((parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100 == 1 ? "disabledBtn" : ""} ${featuredPrematch.odd.split(",")[2].split("|")[0]}" match-odd="${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}" match-home-name="${featuredPrematch.home_team}" match-away-name="${featuredPrematch.away_team}" match-market="${featuredPrematch.odd.split(",")[2].split("|")[2]}" coef-id="${featuredPrematch.odd.split(",")[2].split("|")[0]}" bet-id="${featuredPrematch.odd.split(",")[2].split("|")[0]}" game-id="${featuredPrematch.id}"><i>${featuredPrematch.odd.split(",")[2].split("|")[2]}</i><i>${(Math.floor((parseFloat(featuredPrematch.odd.split(",")[2].split("|")[1]) + Number.EPSILON) * 100) / 100).toFixed(2)}</i></div>` : ``} 
                    </div>
              </div>`;
        }
      });

    // let posts = await getPostsList()
    let view = /*html*/ `
            <div class="pageHeaderTitle">
                <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                <span>${sportName}</span>
                <a href="#/InPlay/${sportId}" class="liveTitleBtn">${_t("Live <i>InPlay</i>")}</a>
            </div>
            <div class="padding-boddy">
            <div class="betModule liveInModule accordionDisable border-top-gb">
                 <div class="betModuleHeaderContainer"> 
                   <a class="betModuleHeaderBtn">
                     <span>${_t("Ndeshjet Kryesore")}</span>
                     <span class="yellowColored"></span>
                   </a>
                   <a class="betHeaderEventBtn" href="#/inPlay">
                     
                   </a>
                 </div>
            </div>
            <div class="featuredPrematchWrapper">
                <div class="featuredPrematchSlider">
                    ${featuredPrematchView}
                </div>            
            </div>
            
            <div class="leagueHeaderLabel border-top-gp">
             <span>${_t("Leagues")}</span>
            </div>
            <div class="leagueHeaderContent">
                ${leagueView}
            </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    $("body .featuredPrematchWrapper").each(function () {
      let featuredSliderWidth = 0;
      $(this)
        .children(".featuredPrematchSlider")
        .children(".featuredPrematchItem")
        .each(function () {
          featuredSliderWidth += $(this).outerWidth() + 3;
        });

      $(this)
        .children(".featuredPrematchSlider")
        .css({
          width: featuredSliderWidth - 3 + "px",
        });
    });
  },
};

export { Leagues, leagues };
